export interface Pager {
  pageIndex: number;
  pageSize: number | undefined;
}

export interface Sorter {
  field: string;
  order: string | undefined;
}

export interface GridProps {
  pagination?: boolean;
  returning?: boolean;
  isCutting?: any;
  pageSize?: number;
  bordered?: boolean;
  sorter?: Sorter;
  dragable?: boolean;
  changeRowColor?: boolean;
  scroll?: { x?: true; y?: number };
  descriptions: Description[];
  entityName?: string;
  url: string;
  dataSource?: any[];
  rowSelectionType?: "checkbox" | "radio";
  style?: React.CSSProperties;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onDrop?: Function;
  onDraw?: (row: any) => JSX.Element;
  onClickRow?: (row: any) => void;
  onSelectChange?: (selectedRowKeys: any, selectedRows: any) => void;
  expandedRow?: (row: any) => any;
  drawerWidth?: number;
  expressions?: Expression[];
  useLegacyAPI?: boolean;
  defaultSelectedRowKeys?: string[];
  onSelect?: unknown;
  onSelectAll?: (
    selected: boolean,
    selectedRows: any[],
    changeRows: any[]
  ) => void;
  onComplete?: (dataSource: any[]) => void;
  pageSizeOptions?: number[];
  rowClassName?: (record: any, index: number) => string;
  step?: 1 | 2;
  homeParams?: any;
  getProId?: (id: any) => void;
}

export class Expression {
  field: string;
  expression: string;
  format?: (value: string) => string;

  constructor(field: string, expression: string) {
    this.field = field;
    this.expression = expression;
  }
}

export interface GridDataOptions {
  url: string;
  dictionaryMapper: { [key: string]: string };
  pagination?: boolean;
  pager?: Pager;
  sorter?: Sorter;
  searchForm: { [key: string]: string };
  fuzzySearch?: string;
  innerDescriptions?: Description[];
  expressions?: Expression[];
}

export interface CountOptions {
  url: string;
  searchForm: { [key: string]: string };
  expressions?: Expression[];
  dictionaryMapper?: { [key: string]: string };
}

export interface Description {
  displayToList?: boolean;
  editable?: boolean;
  dictionary?: string;
  format?: string;
  inputType?: number;
  fixed?: boolean | string;
  align?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  render?: Function;
  width?: number;
  fixedWidthable?: boolean;
  fieldName?: string;
  fieldShowName?: string;
  required?: boolean;
  filter?: string;
  filterable?: boolean;
  sorterable?: boolean;
  min?: number;
  max?: number;
  step?: number;
}

export interface GridData {
  pageSize?: number;
  pageIndex?: number;
  dictionary: { [key: string]: Dictionary[] };
  data: { [key: string]: any }[];
  expressions?: { [key: string]: any };
  total?: number;
}

export interface Dictionary {
  value: string;
  text: string;
}
